import React from 'react';
import { Form, Input, Row, Col } from 'antd';
import { Param } from '../../cliDataSchema';

type InputFieldsProps = {
  paramGroupName: string;
  params: Param[];
};

const ProjectPresetInputFields: React.FC<InputFieldsProps> = ({
  paramGroupName,
  params,
}) => {
  const generateFormItems = (params: Param[]) => {
    if (!params) return null;

    return params.map((param) => (
      <Col span={24} key={param.name}>
        <Form.Item
          label={param.osep_generator_ui_display_name || param.name}
          name={param.name}
          rules={[
            {
              required: true,
              message: `Please enter a value for ${
                param.osep_generator_ui_display_name || param.name
              }`,
            },
          ]}
        >
          {param.osep_generator_ui_is_secret ? <Input.Password /> : <Input />}
        </Form.Item>
      </Col>
    ));
  };

  return (
    <Row gutter={16}>
      <Col span={24}>
        <Form.Item
          label="Preset Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Please enter a preset name',
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Col>
      {generateFormItems(params)}
    </Row>
  );
};

export default ProjectPresetInputFields;
